
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class StateAPI
 * @hideconstructor
 * @classdesc API class that is used to control a state
 */
define([], () => {
	class StateAPI {

		/**
		 * @function StateAPI#setStatus
		 * @description set status of the state
		 * @param {StateAPI#STATUS}
		 */
		setStatus() {}

		/**
		 * @function StateAPI#setError
		 * @description set the error associated to the state
		 * @param {Error} error error object associated to the state
		 */
		setError() {}

		/**
		 * @function StateAPI#clearError
		 * @description clears the error associated to the state
		 */
		clearError() {}

	}



	return StateAPI;
});